import React from "react";
import ReactTooltip from "react-tooltip";
import cx from "classnames";

export function IconTitle(props) {
    const icon = props?.text ? (
        <>
            <i className={cx("fa", `fa-${props.icon}`)} data-tip data-for={props?.columnIdentifier + "-tooltip"} />
            <ReactTooltip id={props?.columnIdentifier + "-tooltip"} effect="solid" place={"top"} delayShow={250} delayHide={125}>
                {props.text}
            </ReactTooltip>
        </>
    ) : (
        <i className={cx("fa", `fa-${props.icon}`)} />
    );

    return (
        <>
            {props?.title}
            {icon}
        </>
    );
}
